import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useAddShareclassMutation } from '@/react-query/mutations/shareclasses'

import { type SchemaType, schema } from './AddShareclassForm.schema'

export interface AddShareclassFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const AddShareclassForm: React.FC<AddShareclassFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const addShareclassMutation = useAddShareclassMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (data, _e) => {
        await addShareclassMutation.mutateAsync(data)
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
